import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./screens/Dashboard/Dashboard";
import Testing from "./Testing";
import Products from "./screens/Products/Products";
import ContactUs from "./screens/ContactUs/ContactUs";
import AboutUs from "./screens/AboutUs/AboutUs";
import { useEffect } from "react";
import PrivacyPolicy from "./screens/PrivacyPolicy/PrivacyPolicy";

function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path={"/"} element={<Dashboard />} />
        <Route path={"/product"} element={<Products />} />
        <Route path={"/contact-us"} element={<ContactUs />} />
        <Route path={"/about-us"} element={<AboutUs />} />
        <Route path={"/testing"} element={<Testing />} />
        <Route path={"/privacy-policy"} element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
